import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Estilos globales de la App
import "./App.css";

// Componentes de Estructura
import Layout from "./components/Layout/Layout";

// Páginas
import HomePage from "./pages/Home/Home";
import AboutPage from "./pages/About/About";
import MyCartPage from "./pages/MyCart/MyCart";
import ShopPage from "./pages/Shop/Shop";
import WishlistPage from "./pages/WishList/WishList";
import ProfilePage from "./pages/Profile/Profile";
import ProductPage from "./pages/Product/Product";
import NotFound from "./pages/NotFound/NotFound";
import Contact from "./pages/Contact/Contact";
import Shipping from "./pages/Shipping/Shipping";

function App() {
  // Simulación de flag para páginas en desarrollo o protegidas
  const isEnabled = false;

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shipping" element={<Shipping />} />

          {/* Rutas Condicionales */}
          <Route 
            path="/mycart" 
            element={isEnabled ? <MyCartPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/wishlist" 
            element={isEnabled ? <WishlistPage /> : <Navigate to="/" />} 
          />
          <Route 
            path="/profile" 
            element={isEnabled ? <ProfilePage /> : <Navigate to="/" />} 
          />

          {/* Error 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;